import { useQuery } from "@tanstack/vue-query";

import KiliApi from "@/data/api/kili/kili-api";
import { SitesQueryKeys } from "@/data/api/kili/sites/sites-query-keys";

export function useGetSitesQuery() {
  return useQuery({
    queryKey: SitesQueryKeys.all,
    queryFn: async () => KiliApi.getSites(),
  });
}
